import type { TUpdateTripTaskReq, TripStatusType } from 'api/swagger';
import type { TTripTaskState } from 'shared/stores/use-trip-task-store';
import { buildLocationPayload, validateLocationByMode } from 'shared/utils/address';
import { ETripTaskStatus } from 'types/trip-task-status';
import { ETripTaskType } from 'types/trips';
import { validateLocationForm } from '../trip-create-task-modal/components/task-details/location-task-form/utils';
import { validateReloadingFromForm } from '../trip-create-task-modal/components/task-details/reloading-from-task-form/utils';
import { validateWarehouseForm } from '../trip-create-task-modal/components/task-details/warehouse-task-form/utils';
import { NON_EDITABLE_TASK_TYPES, SIMILAR_TASK_TYPE_GROUPS } from './constants';

export const validateEditDetailsStep = (state: TTripTaskState) => {
  const { taskType, locationMode, coordinates, address, warehouseId } = state;

  if (!taskType) return false;

  if (taskType === ETripTaskType.customs) {
    return validateLocationByMode(locationMode, coordinates, address);
  }

  if (
    taskType === ETripTaskType.loading ||
    taskType === ETripTaskType.unloading ||
    taskType === ETripTaskType.reloading_to
  ) {
    return validateLocationForm(locationMode, coordinates, address);
  }

  if (taskType === ETripTaskType.loading_wh || taskType === ETripTaskType.unloading_wh) {
    return validateWarehouseForm(warehouseId);
  }

  if (taskType === ETripTaskType.reloading_from) {
    return validateReloadingFromForm(warehouseId, locationMode, coordinates, address);
  }

  return false;
};

export const buildUpdateTripTaskPayload = (state: TTripTaskState): TUpdateTripTaskReq => {
  return {
    type: state.taskType as ETripTaskType,
    warehouseId: state.warehouseId,
    ...buildLocationPayload(state.locationMode, state.coordinates, state.address),
  };
};

export const canEditTripTask = (taskType: ETripTaskType, taskStatus: ETripTaskStatus, tripStatus: TripStatusType) => {
  if (NON_EDITABLE_TASK_TYPES.includes(taskType)) return false;

  if (tripStatus === 'done') return false;

  if (tripStatus != 'planning' && taskType === ETripTaskType.loading_wh) return false;

  if (taskStatus === ETripTaskStatus.done) return false;

  return true;
};

export const getAllowedTaskTypesForEdit = (currentType: ETripTaskType, tripStatus: TripStatusType): ETripTaskType[] => {
  if (tripStatus === 'planning') {
    return Object.values(ETripTaskType).filter(
      (type) => type !== ETripTaskType.trailer_swap && type !== ETripTaskType.return_asset,
    );
  }

  const group = SIMILAR_TASK_TYPE_GROUPS.find((group) => group.includes(currentType));
  return group || [];
};
